import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=067aa0bc&scoped=true"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=067aa0bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067aa0bc",
  null
  
)

export default component.exports